import {Divider} from '@mui/material'
import styled from 'styled-components'
import { Tabs } from '@mui/material'
import {screenS} from '@theme/vars'


export const StyledTabs = styled(Tabs)`
  border-bottom: 1px solid #c4c4c4;
  width: 100%;
  .MuiTabs-flexContainer {
    justify-content: flex-start;
  }
`;

export const StoryFormWrapper = styled.div`
  padding: 0;
`

export const FieldsWrapper = styled.div`
  max-width: 726px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
`

export const RHFSearchPublicationWrapper = styled.div`
  margin-top: 32px;
  width: 100%;

  @media screen and (max-width: ${screenS}) {
    margin-top: 20px;
  }
`

export const HeaderDividerWrapper = styled(Divider)`
  margin-top: 18px;
  width: 100%;

  @media screen and (max-width: ${screenS}) {
    margin-top: 16px;
  }
`

export const BodyDividerWrapper = styled(Divider)`
  margin-top: 30px;
  width: 100%;

  @media screen and (max-width: ${screenS}) {
    margin-top: 24px;
  }
`
